<template>

      <v-container >
      
        <v-layout style="padding: 20px 0px 0px;" >
          <v-flex xs6 sm2 style="align-content: center; text-align: -webkit-right;">
            <div class="dnp-logo-container">
              <a href="https://www.dnp.gov.co" class="dnp-logo-container-img"  target="_blank">
              <v-img
              right
                src="/img/Logo-dnp-version-corta.png"
                lazy-src="../img/Logo-dnp-version-corta.png"
                
                width="60.75px"
                height="90px"
              ></v-img>
              
            </a>
            
            </div>            
            
          </v-flex>
          <v-flex xs6 sm6  style="align-content: center;" >
            <div >  
              <v-img
                :src="path + 'img/siipo-v2-logo.svg'"           
                width="260px"
                height="70px"
              ></v-img>
            </div>
          </v-flex>
          <v-flex xs12 sm4  >

          </v-flex>

        </v-layout>
      
      </v-container>

</template>

<script>
export default {
    name: "global-logo",
    data: function() {
    return {
      date: "",
      timer: "",
      path: process.env.BASE_URL
    };
  },
}
</script>
<style>
.dnp-logo-container {
    border-right: 1px solid #ccc;
    padding-right: 30px !important;
    margin-right: 30px !important;
}
.dnp-logo-container-img {
    width: 75px !important;
    height: 110px !important;
}

</style>